exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".vat-id-instruction{font-style:italic;font-size:13px}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-legal-entity/payment-legal-entity.component.css"],"names":[],"mappings":"AAAA,oBACE,kBAAmB,cACH,CACjB","file":"payment-legal-entity.component.css","sourcesContent":[".vat-id-instruction {\n  font-style: italic;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-legal-entity/payment-legal-entity.component.css
// module id = Uvhx
// module chunks = 0